import { OfficeHeader, Tabs } from "components";
import React, { FC } from "react";

import NICProposalTab from "pages/treaty-schedule/tabs/nic-proposal";
import ReportingTab from "./tabs/reporting";
import { useUrlState } from "utils";

type Props = {};

const tabs: any[] = [
  { name: "NIC Proposal", href: "NIC_PROPOSAL" },
  // { name: "Payment allocation schedule", href: "PAYMENT_ALLOCATION_SCHEDULE" },
  // { name: "Payment Allocation", href: "PAYMENT_ALLOCATION" },
];

const TreatyReportsPage: FC<Props> = () => {
  const [activeTab] = useUrlState("orderStatus");

  return (
    <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
      <OfficeHeader />
      <Tabs tabs={tabs} orderStatus={activeTab} defaultTab={"Reporting"} />
      <div className="flex flex-1 overflow-y-auto">
        <div className="flex-1 mx-auto min-w-0  p-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
          {!activeTab && <ReportingTab />}
          {activeTab === "NIC_PROPOSAL" && <NICProposalTab />}
          {/* {activeTab === "soa_reports" && (
                        <SOAReportTab />
                    )}
                    {activeTab === "monthly_reports" && (
                        <MonthlyReportTab />
                    )} */}
        </div>
      </div>
    </main>
  );
};

export default TreatyReportsPage;
